export type FacetFilterChangedAction = {
    readonly type: 'RETAIN_FILTER_CHANGED';
    retainFilterAcrossSearches: boolean;
};

export function changeRetainFilterChangedAction(
    retainFilterAcrossSearches: boolean,
): FacetFilterChangedAction {
    return {
        type: 'RETAIN_FILTER_CHANGED',
        retainFilterAcrossSearches: retainFilterAcrossSearches,
    };
}
